const nav = document.querySelector("[data-site-nav]");

if (nav) {
  const mobileToggle = nav.querySelector("[data-mobile-nav-toggle]");
  const links = nav.querySelector("[data-primary-nav-links]");
  const buildingsToggle = nav.querySelector("[data-buildings-toggle]");
  const buildingsMenu = nav.querySelector("[data-buildings-menu]");
  const buildingsLinks = [...buildingsMenu.querySelectorAll("a")];
  const mobileQuery = window.matchMedia("(max-width: 880px)");

  function setBuildingsOpen(isOpen, focusTarget = null) {
    buildingsToggle.setAttribute("aria-expanded", String(isOpen));
    buildingsMenu.hidden = !isOpen;
    if (isOpen && focusTarget === "first") buildingsLinks[0]?.focus();
    if (isOpen && focusTarget === "last") buildingsLinks.at(-1)?.focus();
  }

  function setMobileOpen(isOpen, returnFocus = false) {
    mobileToggle.setAttribute("aria-expanded", String(isOpen));
    mobileToggle.textContent = isOpen ? "Close" : "Menu";
    links.dataset.open = String(isOpen);
    if (!isOpen) setBuildingsOpen(false);
    if (returnFocus) mobileToggle.focus();
  }

  function updateSectionCurrent() {
    nav.querySelectorAll('[aria-current="location"]').forEach((link) => {
      link.removeAttribute("aria-current");
    });
    if (location.pathname !== "/" || !location.hash) return;
    nav.querySelector(`[href="/${location.hash}"]`)?.setAttribute("aria-current", "location");
  }

  mobileToggle.addEventListener("click", () => {
    const isOpen = mobileToggle.getAttribute("aria-expanded") !== "true";
    setMobileOpen(isOpen);
    if (isOpen) buildingsToggle.focus();
  });

  buildingsToggle.addEventListener("click", () => {
    setBuildingsOpen(buildingsToggle.getAttribute("aria-expanded") !== "true");
  });

  buildingsToggle.addEventListener("keydown", (event) => {
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      setBuildingsOpen(true, event.key === "ArrowDown" ? "first" : "last");
    }
  });

  buildingsMenu.addEventListener("keydown", (event) => {
    const currentIndex = buildingsLinks.indexOf(document.activeElement);
    if (event.key === "Escape") {
      event.preventDefault();
      setBuildingsOpen(false);
      buildingsToggle.focus();
      return;
    }
    if (currentIndex === -1 || !["ArrowDown", "ArrowUp"].includes(event.key)) return;
    event.preventDefault();
    const direction = event.key === "ArrowDown" ? 1 : -1;
    buildingsLinks[(currentIndex + direction + buildingsLinks.length) % buildingsLinks.length].focus();
  });

  links.addEventListener("click", (event) => {
    if (!event.target.closest("a")) return;
    setBuildingsOpen(false);
    if (mobileQuery.matches) setMobileOpen(false);
  });

  document.addEventListener("pointerdown", (event) => {
    if (!nav.contains(event.target)) setBuildingsOpen(false);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (buildingsToggle.getAttribute("aria-expanded") === "true") {
      setBuildingsOpen(false);
      buildingsToggle.focus();
    } else if (mobileToggle.getAttribute("aria-expanded") === "true") {
      setMobileOpen(false, true);
    }
  });

  mobileQuery.addEventListener("change", () => setMobileOpen(false));
  window.addEventListener("hashchange", updateSectionCurrent);
  updateSectionCurrent();
}
